module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createTextNode("#");
        dom.appendChild(el0, el1);
        var el1 = dom.createComment("");
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, content = hooks.content;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(fragment,1,1,contextualElement);
        dom.insertBoundary(fragment, null);
        content(env, morph0, context, "order.formattedNumber");
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("tr");
        dom.setAttribute(el1,"class","item-block");
        var el2 = dom.createElement("td");
        dom.setAttribute(el2,"class","item-name");
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        var el2 = dom.createElement("td");
        dom.setAttribute(el2,"class","item-amount");
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        var el3 = dom.createTextNode(" ");
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        var el2 = dom.createElement("td");
        dom.setAttribute(el2,"class","item-price");
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, content = hooks.content, inline = hooks.inline, get = hooks.get;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element0 = dom.childAt(fragment, [0]);
        var element1 = dom.childAt(element0, [1]);
        var morph0 = dom.createMorphAt(dom.childAt(element0, [0]),0,0);
        var morph1 = dom.createMorphAt(element1,0,0);
        var morph2 = dom.createMorphAt(element1,2,2);
        var morph3 = dom.createMorphAt(dom.childAt(element0, [2]),0,0);
        content(env, morph0, context, "item.name");
        content(env, morph1, context, "item.amount");
        inline(env, morph2, context, "t", ["c.client_order_block.item_amount"], {});
        inline(env, morph3, context, "currency", [get(env, context, "item.price")], {"order": get(env, context, "order")});
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","order-header");
      var el2 = dom.createComment("");
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","order-time-address");
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","order-time");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      var el4 = dom.createElement("div");
      dom.setAttribute(el4,"class","order-status");
      var el5 = dom.createTextNode("• ");
      dom.appendChild(el4, el5);
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","order-address");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","order-price");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","order-body");
      var el2 = dom.createElement("table");
      dom.setAttribute(el2,"class","order-items");
      var el3 = dom.createElement("tr");
      dom.setAttribute(el3,"class","items-title");
      var el4 = dom.createElement("th");
      dom.setAttribute(el4,"colspan","3");
      var el5 = dom.createComment("");
      dom.appendChild(el4, el5);
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, get = hooks.get, block = hooks.block, inline = hooks.inline, content = hooks.content;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element2 = dom.childAt(fragment, [0]);
      var element3 = dom.childAt(element2, [1]);
      var element4 = dom.childAt(element3, [0]);
      var element5 = dom.childAt(fragment, [1, 0]);
      var morph0 = dom.createMorphAt(element2,0,0);
      var morph1 = dom.createMorphAt(element4,0,0);
      var morph2 = dom.createMorphAt(element4,1,1);
      var morph3 = dom.createMorphAt(dom.childAt(element4, [2]),1,1);
      var morph4 = dom.createMorphAt(dom.childAt(element3, [1]),0,0);
      var morph5 = dom.createMorphAt(dom.childAt(element2, [2]),0,0);
      var morph6 = dom.createMorphAt(dom.childAt(element5, [0, 0]),0,0);
      var morph7 = dom.createMorphAt(element5,1,1);
      block(env, morph0, context, "link-to", ["orders.list.order", get(env, context, "order")], {"class": "order-number"}, child0, null);
      inline(env, morph1, context, "humanizeDate", [get(env, context, "order.created_at"), "D MMM YYYY"], {});
      inline(env, morph2, context, "humanizeDate", [get(env, context, "order.created_at"), " HH:mm"], {});
      content(env, morph3, context, "orderStatus");
      content(env, morph4, context, "order.address_text");
      inline(env, morph5, context, "currency", [get(env, context, "order.final_sum")], {"order": get(env, context, "order")});
      inline(env, morph6, context, "t", ["c.client_order_block.order_contents"], {});
      block(env, morph7, context, "each", [get(env, context, "order.items")], {"keyword": "item"}, child1, null);
      return fragment;
    }
  };
}()));